import { render } from "./DownloadBox.vue?vue&type=template&id=0e8de36a&scoped=true"
import script from "./DownloadBox.vue?vue&type=script&lang=js"
export * from "./DownloadBox.vue?vue&type=script&lang=js"

import "./DownloadBox.vue?vue&type=style&index=0&id=0e8de36a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8de36a"]])

export default __exports__